// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type { PostZendeskConfigsChatSaveAndAuthBody, BaseResponsestring } from '../../../types';

/**
 * saveAndAuth
 *
 * @export
 * @tags zendesk-config-chat-controller
 * @link [POST] /zendeskConfigs/chat/saveAndAuth
 */
export function postZendeskConfigsChatSaveAndAuth(
    data: PostZendeskConfigsChatSaveAndAuthBody
): Promise<BaseResponsestring>;
export function postZendeskConfigsChatSaveAndAuth(
    data: PostZendeskConfigsChatSaveAndAuthBody,
    options: ApiOptions<never, never>
): Promise<BaseResponsestring>;
export function postZendeskConfigsChatSaveAndAuth(
    data: PostZendeskConfigsChatSaveAndAuthBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponsestring> {
    return request<PostZendeskConfigsChatSaveAndAuthBody, never, never>(
        '/zendeskConfigs/chat/saveAndAuth',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postZendeskConfigsChatSaveAndAuth',
        }
    );
}

export const meta = [
    {
        tags: ['zendesk-config-chat-controller'],
        path: '/zendeskConfigs/chat/saveAndAuth',
        method: 'post',
    },
];
